import React, { useState } from "react";

const TOCCompare = () => {
  const [index, setIndex] = useState(-1);

  const list = [
    "Filename Validation",
    "NCX and TOC Compare",
    "NAV and NCX Compare",
    "Guide Information",
    "NCX Title Case Checking",
  ];

  const handleToggle = (i) => {
    if (index === i) {
      setIndex(-1);
    } else {
      setIndex(i);
    }
  };
  return (
    <div className="flex flex-col w-full">
      <div className="p-8 flex flex-col gap-8 h-[100%] min-h-[70vh]">
        <div className="flex w-full justify-between text-left items-center">
          <h1 className="text-24 font-semibold">TOC vs NCX Compare</h1>
        </div>
        <div className="flex flex-col text-left gap-4 cursor-pointer">
          {list.map((title, i) => (
            <div
              key={i}
              onClick={() => handleToggle(i)}
              className="flex flex-col bg-white p-6 rounded-[16px] text-20 font-medium border-[1px] border-commonborder shadow-commonshadow"
            >
              <div className="flex justify-between">
                <h>{title}</h>
                <img
                  className={`transition-rotate duration-500 ${
                    index === i ? "rotate-[180deg]" : "rotate-[0deg]"
                  }`}
                  src={
                    process.env.PUBLIC_URL + "/images/downarrowhighlight.svg"
                  }
                  alt="open/close"
                />
              </div>
              <div
                className={`overflow-auto transition-h duration-300 ease-in-out  ${
                  index === i
                    ? "h-[300px] max-h-[400px]"
                    : "h-[0px] max-h-0 mt-0"
                }`}
              >
                <div className="mt-6">
                  <p>Hello, this is the content.</p>
                  <p>Hello, this is the content.</p>
                  <p>Hello, this is the content.</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TOCCompare;
